module.exports = __webpack_public_path__ + "img/ezstudio-logo-only-logo.755466e3.png";